/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
type Falsy = undefined | null | false | '' | 0

export const setInputIfDigits = (params: {
  inputSetter: (value: string) => void
  value: string
}) => {
  const { inputSetter, value } = params
  if (/^\d*$/.test(value)) {
    inputSetter(value)
  }
}

export const stripLeadingZeroes = (value: string) => {
  value.replace(/^0+/, '')
  return value
}

const padLeadingZeroes = (length: number) => (value: string) => {
  if (value.length < length) {
    return `${'0'.repeat(length - value.length)}${value}`
  }
  return value
}

export const padTo8LeadingZeroes = padLeadingZeroes(8)
export const padTo9LeadingZeroes = padLeadingZeroes(9)

export const mergeClassNames = (...classNames: (string | Falsy)[]) =>
  classNames.filter(className => className).join(' ')

export const computeZone = (slot_number: number) => (slot_number / 10000000).toFixed(0)
export const computeAisle = (slot_number: number) => ((slot_number / 100000) % 100).toFixed(0)
export const computeSlot = (slot_number: number) => (slot_number % 100000).toFixed(0)
